import React from 'react';
import { ReactComponent as Best } from '../svg/best.svg';
import { ReactComponent as Hot } from '../svg/hot.svg';
import { ReactComponent as New } from '../svg/new.svg';
import { ReactComponent as Top } from '../svg/top.svg';
import { ReactComponent as Controversial } from '../svg/controversial.svg';
import { ReactComponent as Old } from '../svg/old.svg';
import { ReactComponent as Subscribed } from '../svg/subscribed.svg';

import { Paper, Tabs, Tab, SvgIcon } from '@material-ui/core';
import { useSortTabStyles } from '../styles/muiStyles';

const SortTabBar = ({ sortBy, handleTabChange, subscribedTab, user }) => {
  const classes = useSortTabStyles();

  return (
    <Paper variant="outlined" className={classes.mainPaper}>
      <Tabs
        value={sortBy}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><New /></SvgIcon>}
          label="New"
          value="new"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><Hot /></SvgIcon>}
          label="Hot"
          value="hot"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
        {subscribedTab && user && (
          <Tab
            icon={<SvgIcon style={{ fontSize: '18px' }}><Subscribed /></SvgIcon>}
            label="Subscribed"
            value="subscribed"
            sx={{
              minHeight: 36,
              '& .MuiTab-wrapper': {
                fontSize: '0.6rem',
                padding: 0,
                gap: '2px',
                flexDirection: 'column',
              },
            }}
          />
        )}
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><Best /></SvgIcon>}
          label="Best"
          value="best"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><Top /></SvgIcon>}
          label="Top"
          value="top"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><Controversial /></SvgIcon>}
          label="Controversial"
          value="controversial"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
        <Tab
          icon={<SvgIcon style={{ fontSize: '18px' }}><Old /></SvgIcon>}
          label="Old"
          value="old"
          sx={{
            minHeight: 36,
            '& .MuiTab-wrapper': {
              fontSize: '0.6rem',
              padding: 0,
              gap: '2px',
              flexDirection: 'column',
            },
          }}
        />
      </Tabs>
    </Paper>
  );
  
  

};

export default SortTabBar;
